import { motion } from 'framer-motion';
import { Download, Gavel, Handshake, ShieldCheck } from 'lucide-react';
const compactFeatureCards = [
  {
    title: 'Descargas de listas de buena fe',
    description:
      'En ProTorneos facilitamos la organización del torneo y aseguramos un control rápido y confiable de los jugadores habilitados.',
    icon: Download,
  },
  {
    title: 'Partidos amistosos',
    description:
      'Son encuentros fuera de la competencia oficial que permiten a los equipos fortalecerse, probar estrategias y disfrutar del fútbol sin presión.',
    icon: Handshake,
  },
  {
    title: 'Validación de identidad',
    description:
      '¡Más transparencia en tu torneo! Evitá suplantaciones y asegurate de que jueguen solo los habilitados con nuestro sistema de verificación.',
    icon: ShieldCheck,
  },
  {
    title: 'Sanciones por equipo',
    description:
      'La aplicación de sanciones con quita de puntos y suspensión garantiza el cumplimiento del reglamento y promueve la justicia y el fair play en el torneo.',
    icon: Gavel,
  },
] as const;

export function StatsSection() {
  return (
    <section className="px-4 py-9 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-6xl">
        <div id="tablas-de-posiciones" className="scroll-mt-24">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.4 }}
          >
            <h2 className="font-display text-3xl font-bold sm:text-4xl">Tablas de posiciones</h2>
            <p className="mt-3 max-w-3xl text-sm text-zinc-300">
              Visualizá la tabla de posiciones con resultados de todas las competiciones amateur y ligas
              profesionales
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.45 }}
            className="panel mt-5 w-full min-w-0 overflow-hidden p-3 sm:p-4 lg:p-5"
          >
            <img
              src={`${process.env.PUBLIC_URL}/tabla-posiciones.svg`}
              alt="Tabla de posiciones en Protorneos"
              className="block h-auto w-full max-w-none object-contain object-center"
              width={658}
              height={104}
              loading="lazy"
              decoding="async"
            />
          </motion.div>
        </div>

        <div className="mt-6 flex flex-col gap-5">
          <motion.article
            id="estadisticas-avanzadas"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.45 }}
            className="panel scroll-mt-24 flex w-full min-w-0 flex-col overflow-hidden p-3 sm:p-4 lg:p-5"
          >
            <h3 className="font-display text-4xl font-bold">Estadísticas avanzadas</h3>
            <p className="mt-3 text-sm text-zinc-300">
              Análisis de rendimiento y simulación de datos en tiempo real para cada equipo.
            </p>
            <div className="mt-5 w-full min-w-0">
              <img
                src={`${process.env.PUBLIC_URL}/estadisticas.svg`}
                alt="Estadísticas avanzadas en Protorneos"
                className="block h-auto w-full max-w-none object-contain object-center"
                width={658}
                height={130}
                loading="lazy"
                decoding="async"
              />
            </div>

          </motion.article>
        </div>

        <div className="mt-6 grid w-full min-w-0 grid-cols-1 gap-5 sm:grid-cols-2">
          {compactFeatureCards.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.article
                key={feature.title}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.38, delay: index * 0.05 }}
                className="flex min-h-full min-w-0 w-full flex-col rounded-2xl border border-brand-border bg-brand-panel/90 p-6 shadow-panel sm:p-7 lg:p-8"
              >
                <div className="mb-4 inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-brand-yellow/40 bg-brand-yellow/10 text-brand-yellow lg:h-14 lg:w-14">
                  <Icon className="h-6 w-6 lg:h-7 lg:w-7" strokeWidth={1.75} aria-hidden />
                </div>
                <h4 className="font-display text-xl font-bold leading-snug text-white lg:text-2xl">{feature.title}</h4>
                <p className="mt-3 max-w-none text-sm leading-relaxed text-zinc-300 lg:text-base">
                  {feature.description}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
